import { gql } from '@apollo/client'
import { STATUS_DELIVERED } from '../types/Order'

export const GET_STATE_VALUE = gql`
  query ordersAggs($filters: JSON) {
    ordersAggs(
      filters: $filters
      size: 0,
      query: {
        bool: {
          filter: [
            {
              term: {
                status_translate_keyword: "${STATUS_DELIVERED}"
              }
            }
          ]
        }
      },
      aggs: {
        estado: {
          terms: {
            field: "state_name.keyword",
            size: 30
          },
          aggs: {
            media: {
              avg: {
                field: "total"
              }
            },
            minima: {
              min: {
                field: "total"
              }
            },
            maxima: {
              max: {
                field: "total"
              }
            }
          }
        }
      }
    ) {
      aggregations
    }
  }
`

export const GET_WEEK_VALUE = gql`
  query ordersAggs($filters: JSON) {
    ordersAggs(
      filters: $filters, 
      size: 0,
      query: {
        bool: {
          filter: [
            {
              term: {
                status_translate_keyword: "${STATUS_DELIVERED}"
              }
            }
          ]
        }
      },
      aggs: {
        data: {
          terms: {
            script: {
              lang: "painless",
              source: "doc['created_at'].value.getDayOfWeek()"
            },
            order: {
              _key: "asc"
            }
          },
          aggs: {
            media: {
              avg: {
                field: "total"
              }
            },
            minima: {
              min: {
                field: "total"
              }
            },
            maxima: {
              max: {
                field: "total"
              }
            }
          }
        }
      }
    ) {
      aggregations
    }
  }
`
